<app-not-authorized-notice has="userRoleManagement"></app-not-authorized-notice>

<div class="footer-container" [appHasSystemCapability] has="userRoleManagement">
	<app-assign-role [companyId]="companyId" (selectionChangedEvents)="onSelectionChangedEvent($event)">
	</app-assign-role>
</div>
